import {
  Component,
  Renderer2,
  OnInit,
  ElementRef,
  Inject,
  AfterViewInit,
  AfterViewChecked,
  ViewChildren,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormControl } from "@angular/forms";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { UserService } from "../../services/user.service";
import { User } from "../../models/user";
import { FileService } from "../../services/file.service";
import { File } from "../../models/file";
import { FolderService } from "../../services/folder.service";
import { FolderPermissionService } from "../../services/folderpermission.service";
import { FilesPermissionGroupService } from "../../services/filespermissiongroup.service";
import { Folder } from "../../models/folder";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import swal from "sweetalert2";
import { DinamicData, Cell } from "../../models/dinamic-data";
import { DomSanitizer } from "@angular/platform-browser";
import { ArchiveService } from "../../services/archive.service";
import { Methods } from "../../shared/methods";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { of } from "rxjs";
import { TitleService } from '../../services/title.service';

declare const require: any;

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: any[][];
}

declare const $: any;

interface FileReaderEventTarget extends EventTarget {
  result: string;
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}

export interface UserList {
  value: string;
  name: string;
}

export interface GroupList {
  value: string;
  name: string;
  data: any;
}

@Component({
  selector: "app-listshowfiles-cmp",
  templateUrl: "listshowfiles.component.html",
  styleUrls: ["listshowfiles.component.scss"],
  providers: [
    UserService,
    FileService,
    FolderService,
    FolderPermissionService,
    FilesPermissionGroupService,
  ],
})
export class ListshowfilesComponent
  implements OnInit, AfterViewInit, AfterViewChecked
{
  public mtds: Methods = new Methods();
  public advancedsearchtext = "";
  name: string;
  public tableFolder;
  animal: string;
  public dataTable: DataTable;
  public dataFolder: DataTable;
  public dataTableSearch: DataTable;
  public dataTablePOSearch: DataTable;
  public privilegio;
  public showsearchResults = 0;
  sexos = [
    { value: "1", viewValue: "Hombre" },
    { value: "0", viewValue: "Mujer" },
  ];
  // showMsgSearching= false;
  loader = false;
  public showMsgSearchingNotResults = 0;
  public pacientes: Array<User>;
  public files: Array<File>;
  public folder: Array<Folder>;
  public permissions: any;
  public identity;
  public token;
  public endpointType = "traditional"; // 's3' or 'traditional'
  public cloudFrontUrl = "";
  public pages;
  public pagePrev;
  public pageNext;
  public filter = 0;
  public order = 0;
  public searchString;
  public hasparent = 0;
  public user;
  public typeFolders;
  public folderinterno;
  public folderNew;
  public file;
  public userlogged;
  public apiCompany;
  public status_user;
  selectedFile: File;
  public idFolder;
  public folderPermissions;
  public permissionsShow;
  public idOwner;
  public uploadData = new FormData();
  public stringPath = "/";
  public sanitizerGlobal: DomSanitizer;
  public fullPermission = 0;
  public contarFolders = 0;
  public contarFiles = 0;
  public companyId;
  public idfoldertomove: number = 0;
  public idfiletomove: any = 0;
  myControl = new FormControl();
  myControlClientes = new FormControl();
  myControlGroups = new FormControl();
  public showsearch = 0;
  public poID = null;
  public filepermissionSelected: any = null;
  public bulk: Array<any> = [];

  public searchinitialdate: any = "";
  public searchenddate: any = "";
  public daterangeadvancedsearch: any = "All";
  public receiveresultsadvancedsearch: any = "4";
  public selectedSearchType: any = "1";

  public filtros = [];
  public campoBusqueda = "";

  public itemsPorPagina = "10";
  public paginaActual = 1;
  public totalItems = 0;
  public totalPaginas = 1;

  public filtrosArchived = [];
  public campoBusquedaArchived = "";

  public itemsPorPaginaArchived = "10";
  public paginaActualArchived = 1;
  public totalItemsArchived = 0;
  public totalPaginasArchived = 1;

  public data: DinamicData = new DinamicData();

  public dataFiles: DinamicData = new DinamicData([
    "check",
    "Type",
    "ID",
    "Report Name",
    "Created Date",
    "Actions",
  ]);

  public bulkFiles: Array<any> = [];
  public filtrosFiles = [];
  public campoBusquedaFiles = "";

  public itemsPorPaginaFiles = "10";
  public paginaActualFiles = 1;
  public totalItemsFiles = 0;
  public totalPaginasFiles = 1;

  public urlUpload;

  clientes: UserList[] = [];

  filteredClientes: Observable<UserList[]>;
  filteredGroups: Observable<UserList[]>;

  // State for dropzone CSS toggling
  isHovering: boolean;

  public loading: boolean = false;
  public tagGroups: string[][];
  public permissionsgroups: GroupList[] = [];

  public breadcrumbs: any[] = [];

  constructor(
    public dialog: MatDialog,
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService,
    private _fileService: FileService,
    private _folderService: FolderService,
    private _folderPermissionService: FolderPermissionService,
    public sanitizer: DomSanitizer,
    private archiveService: ArchiveService,
    private _filesPermissionsGroupsService: FilesPermissionGroupService,
    private renderer: Renderer2,
    private el: ElementRef,private titleServices: TitleService
  ) {
    this.urlUpload = this.sanitizer.bypassSecurityTrustResourceUrl(
      "https://greenteksolutionsllc.com/loading1.gif"
    );

    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    /*this._route.params.subscribe(val => {
    // put the code from `ngOnInit` here
    console.log("subscribe route fired!");

  })*/
  }

  action(e) {
    // console.log(e);

    switch (e.action) {
      case "Show":
        this._router.navigate(["/tables/listfiles", e.id]);
        break;
      case "Remove":
        this.deleteFolderPrompt(e.id);
        break;
      default:
        break;
    }
  }

  // showsrch() {
  //   if (this.showsearch) this.showsearch = 0;
  //   else this.showsearch = 1;
  // }

  public showposearch = 0;
  public advancedpotext = "";

  // showposrch() {
  //   if (this.showposearch) this.showposearch = 0;
  //   else this.showposearch = 1;
  // }
  public filterrigh = "";
  public sortStates = ""; 
  handleRightClick(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrigh ){
      if(this.sortStates === "DESC"){
        this.sortStates = "ASC"
      }else{
        this.sortStates = "DESC"
      }
    } else{
      this.sortStates = "ASC"
    }
    this.filterrigh = columnKey;

    this.segundogetSubFolders(null,false,true);
  }
  public filterrighfile = "";
  public sortStatesfile = ""; 
  handleRightClickfile(data: any): void {
    const columnKey = data.columnName.key;
    if(columnKey === this.filterrighfile ){
      if(this.sortStatesfile === "DESC"){
        this.sortStatesfile = "ASC"
      }else{
        this.sortStatesfile = "DESC"
      }
    } else{
      this.sortStatesfile = "ASC"
    }
    this.filterrighfile = columnKey;

    this.getFilesFolder(null,false);
  }
  getGroupsByUser() {
    this.loading = true;

    this._filesPermissionsGroupsService
      .listByUser(this.token, this.identity.sub)
      .subscribe(
        (response) => {
          if (response.status == "success") {
            let element;

            this.tagGroups = [];

            for (element of response.data) {
              this.tagGroups.push([element.id, element.name]);

              this.permissionsgroups.push({
                value: element.id,
                name: element.name,
                data: element.data,
              });
            }
          } else {
            if (response.msg == "Authorization not valid") {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            } else {
              //this.showSwal('error', 'ERROR!', response.msg);
              this.tagGroups = [];
            }
          }
          this.loading = false;
        },
        (error) => {
          console.log(<any>error);
          this.showSwal("error");
          this.loading = false;
        }
      );
  }

  changeDateRange() {
    if (this.daterangeadvancedsearch == "All") {
      this.searchinitialdate = "";
      this.searchenddate = "";
    }
  }

  searchAdvanced() {
    // $("#showMsgSearching").show();
    this.loader = true;
    this.dataTableSearch.dataRows = [];
    this.showMsgSearchingNotResults = 0;

    this._fileService
      .searchBetweenFiles(
        this.privilegio.sub,
        this.idFolder,
        this.advancedsearchtext,
        this.selectedSearchType,
        this.receiveresultsadvancedsearch,
        this.daterangeadvancedsearch,
        this.searchinitialdate,
        this.searchenddate
      )
      .subscribe(
        (response) => {
          // $("#showMsgSearching").hide();
          this.loader = false;
          if (this.receiveresultsadvancedsearch == "5") {
            $("#modalAdvancedSearch").modal("hide");
            swal.fire({
              html: `
                <img src="./assets/img/email_icon.svg" width="120px">
                <h3 style="font-family: 'Roboto' !important; font-weight: 600 !important; font-size: 30px !important; color: #545454 !important;">The search has begun!</h3>
                <br>
                <p>You will receive an email with the search results in a few minutes.</p>
              `,
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false,
            });
            return false;
          } else if (this.receiveresultsadvancedsearch == "4") {
            if (response.length > 0) {
              this.showsearchResults = 1;
              this.showMsgSearchingNotResults = 0;
            } else {
              this.showsearchResults = 0;
              this.showMsgSearchingNotResults = 1;
            }
            response.forEach(
              function (element) {
                //   console.log(element.file);
                this.dataTableSearch.dataRows.push([
                  element.idfile,
                  element.filename,
                  element.idFolderDB,
                  "",
                ]);
                // console.log("this.dataTableSearch.dataRows => ", this.dataTableSearch.dataRows);
              }.bind(this)
            );
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  public showMsgPOSearchingNotResults = 0;
  public showsearchPOResults = 0;

  searchPO() {
    $("#showMsgPOSearching").show();
    this.dataTablePOSearch.dataRows = [];
    this.showMsgPOSearchingNotResults = 0;

    this._fileService
      .searchPO(this.privilegio.sub, this.advancedpotext, this.apiCompany)
      .subscribe(
        (response) => {
          $("#showMsgPOSearching").hide();
          // console.log(response);
          //console.log(response.length);
          if (response.length > 0) {
            this.showsearchPOResults = 1;
            this.showMsgPOSearchingNotResults = 0;
          } else {
            this.showsearchPOResults = 0;
            this.showMsgPOSearchingNotResults = 1;
          }
          response.forEach(
            function (element) {
              //  console.log(element.file);
              this.dataTablePOSearch.dataRows.push([
                element.id,
                element.folderName,
                "",
              ]);
            }.bind(this)
          );
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  ngOnInit() {
    // console.log("6666");
    // console.log("ngOnInit fired!");

    this.sanitizerGlobal = this.sanitizer;
    this.folderPermissions = new Folder(1, "", "", "", 0, "", 1, 0, 1, 0);
    this.folderPermissions.permissions = [];
    this.permissionsShow = [];

    if (
      this.privilegio.level == "ADMINISTRATOR" ||
      this.privilegio.level == "MANAGER" ||
      this.privilegio.level == "PURCHASINGREP" ||
      this.privilegio.level == "worker" ||
      this.privilegio.level == "WAREHOUSE SUPERVISOR" ||
      this.privilegio.level == "TECH SUPERVISOR" ||
      this.privilegio.level == "TECHREP" ||
      this.privilegio.level == "CLERICALREP"
    ) {
      this.fullPermission = 1;
    }

    if (this.identity == null && this.identity.sub) {
      localStorage.clear();
      this._router.navigate(["/pages/lock"]);
    } else {
    }

    if (this.token) {
      this._userService.getUser(this.token, this.identity.sub).subscribe(
        (response) => {
          // console.log(response);
          if (response.status == "success") {
            this.userlogged = response.data;

            this.apiCompany = this.userlogged.companyLinked.apiToken;
            // console.log(this.apiCompany);
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    }

    this.getGroupsByUser();

    let intentos = 0;
    //do{
    //this.getFolderInfo();

    //inicio params
    this._route.params.forEach((params: Params) => {
      let id = +params["id"];
      let page = 1;
      this.idFolder = id;
      //console.log("iniciamos");

      let parent = this.idFolder;

      if (
        this.privilegio.level == "ADMINISTRATOR" ||
        this.privilegio.level == "MANAGER" ||
        this.privilegio.level == "PURCHASINGREP" ||
        this.privilegio.level == "worker" ||
        this.privilegio.level == "WAREHOUSE SUPERVISOR" ||
        this.privilegio.level == "TECH SUPERVISOR" ||
        this.privilegio.level == "TECHREP" ||
        this.privilegio.level == "CLERICALREP"
      ) {
        this.typeFolders = "ALL";
      } else if (this.privilegio.level == "worker") {
        this.typeFolders = "ALL";
      } else {
        this.typeFolders = "USER";
      }

      this.loading = true;
      this.contarFolders = 0;

      //1-inicio getFolder
      let varinicio = this.inicioGetFolder();

      //1-fin getFolder

      //2-inicia getSubFolders
      //  let varsegundo=  this.segundogetSubFolders();
      //console.log("varsegundo: " + varsegundo);
      //2-fin getSubFolders

      //3- obtenemos permisos del folder
      console.log("3- get permisos id => ", id);
      this.permissions = [];
      this._folderPermissionService.getFolder(this.token, id).subscribe(
        (response) => {
          console.log("3- get permisos => ", response);

          if (response.status == "success") {
            this.permissions = response.data;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
      //3- fin permisos del folder
    });
    // fin params

    intentos++;
    //}while(this.folderinterno == null && intentos <3);

    this.dataTableSearch = {
      headerRow: ["File Name", "Actions"],
      footerRow: ["File Name", "Actions"],

      dataRows: [],
    };

    this.dataTablePOSearch = {
      headerRow: ["Folder Name", "Actions"],
      footerRow: ["Folder Name", "Actions"],

      dataRows: [],
    };

    this.getArchivedFolders();
    this.optionSelectMenuTrigger = "foldersFiles";
    this.archivedFolders = false;
    this.titleServices.setTitle('Reports');
  }

  toggleHover(event: boolean) {
    this.isHovering = event;
  }

  deletePermiso(permiso) {
    this.loading = true;
    let me = this;
    swal
      .fire({
        title: "Are you sure?",
        text: "You are going to delete this permission.",

        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",

        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-success",
        },

        buttonsStyling: false,
      })
      .then(function (request) {
        if (request.value == true) {
          me._folderPermissionService.delete(me.token, permiso.id).subscribe(
            (response) => {
              if (response.status == "success") {
                //this._router.navigate(['/']);
                $("#permi-" + permiso.id).hide();
                // this.getFiles(this.idFolder);
                //console.log("deleted");
                swal.fire({
                  title: "Deleted!",
                  text: "Permission has been deleted.",

                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                  buttonsStyling: false,
                });
                me.loading = false;
              }
            },
            (error) => {
              console.log(<any>error);
              alert("Error");
            }
          );
        } else {
          me.loading = false;
          swal.fire({
            title: "Cancelled",
            text: "",

            customClass: {
              confirmButton: "btn btn-info",
            },
            buttonsStyling: false,
          });
        }
      });
  }

  openNuevoFolder(): void {
    this.folderNew = new Folder(
      1,
      "",
      "",
      "",
      0,
      "",
      this.idFolder,
      0,
      1,
      this.companyId
    );
    // console.log(this.companyId);
    //console.log(this.folderNew);
    let dialogRef = this.dialog.open(NewSubFolder, {
      width: "620px",
      data: {
        folder: this.folderNew,
        folderParent: this.idFolder,
        permissions_imported: this.permissions,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      //  result.folder.user_id = result.user_id.value;
      if (result && result.permissions) {
        result.permissions = result.permissions.map(
          (permission: any) => permission.value
        );
      }

      console.log(result, "result");
      //console.log(result.folder);

      this._folderService.create(this.token, result).subscribe(
        (response) => {
          //console.log(response);
          this.status_user = response.status;

          if (this.status_user != "success") {
            this.status_user = "error";
          } else {
            this.showSwal("success");
            //this.animal = result;
            this.getAllPacientes();
            this.segundogetSubFolders();
            this.contarFolders++;
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }

  public loadingFolders = false;

  loadingDataFolders = true;
  loadingDataFiles = true;
  public noPaymentFromClientAlert:boolean = false;
  public async segundogetSubFolders(
    e = null,
    newfilter = true,
    filters = false
  ) {
    this.noPaymentFromClientAlert = false;
    this.filtros = !filters ? [] : this.filtros;

    this.loadingDataFolders = true;
    this.loadingDataFiles = true;
    this.loading = true;
    this.loadingFolders = true;
    this.bulk = [];
    this.data.rows = [];
    let response = await this._folderService
      .getSubFoldersv1(
        this.token,
        e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,
        e !== null
          ? (this.campoBusqueda = e.search)
          : (this.campoBusqueda = ""),
        this.filtros,
        this.typeFolders,
        this.idFolder,
        this.filterrigh,this.sortStates
      )
      .subscribe(
        (response) => {
          //console.log("2- get subfolder");
          console.log(response);
          if(response.code == 209){
            this.noPaymentFromClientAlert = true;
          }
          else if (response.status == "success") {
            this.paginaActual = Number(response.page_actual);
            this.itemsPorPagina = String(response.items_per_page);
            this.totalItems = Number(response.total_items_count);
            this.setOptionsButtonSelect();
            this.totalPaginas = Number(response.total_pages);

            if (newfilter) {
              if (this.folderinterno?.hasParent === 0) {
                this.filtros = [
                  null,
                  null,
                  {
                    key: "filter_id",
                    title: "ID",
                    value: "",
                    type: "contains",
                    key_type: "filter_id_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_vendor",
                    title: "Folder Name",
                    value: "",
                    type: "contains",
                    key_type: "filter_vendor_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_reference",
                    title: "Reference",
                    value: "",
                    type: "contains",
                    key_type: "filter_reference_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_state",
                    title: "State",
                    value: "",
                    type: "contains",
                    key_type: "filter_state_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_city",
                    title: "City",
                    value: "",
                    type: "contains",
                    key_type: "filter_city_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_status",
                    title: "Status",
                    value: "",
                    type: "contains",
                    key_type: "filter_status_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_date",
                    title: "Created Date",
                    value: "",
                    type: "contains",
                    key_type: "filter_date_type",
                    type_options: [
                      { value: "contains", name: "Contains" },
                    ],
                  },
                  null,
                ];
              } else {
                this.filtros = [
                  null,
                  null,
                  {
                    key: "filter_id",
                    title: "ID",
                    value: "",
                    type: "contains",
                    key_type: "filter_id_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_vendor",
                    title: "Folder Name",
                    value: "",
                    type: "contains",
                    key_type: "filter_vendor_type",
                    type_options: [
                      { value: "nofilter", name: "No Filter" },
                      { value: "contains", name: "Contains" },
                      { value: "startswith", name: "Starts With" },
                      { value: "endswith", name: "Ends With" },
                      { value: "equalto", name: "Equal To" },
                    ],
                  },
                  {
                    key: "filter_date",
                    title: "Created Date",
                    value: "",
                    type: "contains",
                    key_type: "filter_date_type",
                    type_options: [
                      { value: "contains", name: "Contains" },
                    ],
                  },
                  null,
                ];
              }
            }

            this.pacientes = response.data;

            let actionButtons = [
              { icon: "remove_red_eye", action: "Show", color: "info" },
            ];

            if (
              this.identity.role === "ADMINISTRATOR" ||
              this.identity.role === "MANAGER"
            ) {
              actionButtons.push({
                icon: "delete_outline",
                action: "Remove",
                color: "danger",
              });
            }

            if (this.folderinterno?.hasParent === 0) {
              this.data.headers = [
                "check",
                "Type",
                "ID",
                "Folder Name",
                "Reference",
                "State",
                "City",
                "Status",
                "Created Date",
                "Actions",
              ];
            } else {
              this.data.headers = [
                "check",
                "Type",
                "ID",
                "Folder Name",
                "Created Date",
                "Actions",
              ];
            }

            for (let element of response.data) {
              if (this.folderinterno?.hasParent === 0) {
                this.data.rows.push([
                  new Cell(element.id, { type: "checkbox" }),
                  new Cell("", { icon: "folder" }),
                  new Cell(element.id),
                  new Cell(element.name),
                  new Cell(response.references[element.name] || ""),
                  new Cell(element.poState),
                  new Cell(element.poCity),
                  new Cell(element.poStatus),
                  new Cell(
                    element.createdAt != null
                      ? 
                          element.createdAt
                      : null,
                    { type: "full-date" }
                  ),
                  new Cell(actionButtons, { type: "actions" }),
                ]);
              } else {
                this.data.rows.push([
                  new Cell(element.id, { type: "checkbox" }),
                  new Cell("", { icon: "folder" }),
                  new Cell(element.id),
                  new Cell(element.name),
                  new Cell(
                    element.createdAt != null
                      ?
                          element.createdAt
                      : null,
                    { type: "full-date" }
                  ),
                  new Cell(actionButtons, { type: "actions" }),
                ]);
              }
            }
            this.loadingDataFolders = false;

            //this.getFiles(this.idFolder);
            //console.log("2- permiso " + this.fullPermission);
            // inicio fullPermission
            if (this.fullPermission == 1) {
              //console.log("2- entramos full permission");

              this.getFilesFolder();

              /*this.contarFiles = 0;
              // inicio getFilesFolder
              this._fileService
                .getFilesFolder(this.token, this.idFolder)
                .subscribe(
                  (response) => {
                    //console.log("2- get filesfolder");
                    // console.log(response);
                    if (response.status == "success") {
                      this.dataTable = {
                        headerRow: [
                          "ID",
                          "Report Name",
                          "Created Date",
                          "Actions",
                        ],
                        footerRow: [
                          "ID",
                          "Report Name",
                          "Created Date",
                          "Actions",
                        ],

                        dataRows: [],
                      };

                      this.dataTable.dataRows = [];

                      response.data.forEach(
                        function (element) {
                          this.contarFiles++;
                          this.dataTable.dataRows.push([
                            element.id,
                            element.file,
                            element.createdAt,
                            "",
                          ]);
                        }.bind(this)
                      );

                      

                   

                    }
                    this.loadingDataFiles = false;
                  },
                  (error) => {
                    console.log(<any>error);
                    this.loadingDataFiles = true;
                  }
                );*/
              // fin getFilesFolder
            } else {
              //console.log("no entramos");
            }
            // fin fullPermission
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
          this.loading = false;
          this.loadingFolders = false;
        },
        (error) => {
          console.log(<any>error);
          this.loading = false;
          this.loadingFolders = false;
          this.loadingDataFolders = true;
        }
      );

    return response;
  }

  getFilesFolder(e = null, newfilter = true) {
    this.bulkFiles = [];
    this.dataFiles.rows = [];
    this.contarFiles = 0;
    // inicio getFilesFolder
    this._fileService
      .getFilesFolderv1(
        this.token,
        e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,
        e !== null
          ? (this.campoBusquedaFiles = e.search)
          : (this.campoBusquedaFiles = ""),
        this.filtrosFiles,
        this.idFolder,
        this.filterrighfile,this.sortStatesfile
      )
      .subscribe(
        (response) => {
          //console.log("2- get filesfolder");
          // console.log(response);
          if (response.status == "success") {
            this.paginaActualFiles = Number(response.page_actual);
            this.itemsPorPaginaFiles = String(response.items_per_page);
            this.totalItemsFiles = Number(response.total_items_count);
            this.setOptionsButtonSelect();
            this.totalPaginasFiles = Number(response.total_pages);

            if (newfilter) {
              this.filtrosFiles = [
                null,
                null,
                {
                  key: "filter_id",
                  title: "ID",
                  value: "",
                  type: "contains",
                  key_type: "filter_id_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_report",
                  title: "Report Name",
                  value: "",
                  type: "contains",
                  key_type: "filter_report_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_date",
                  title: "Created Date",
                  value: "",
                  type: "contains",
                  key_type: "filter_date_type",
                  type_options: [ { value: "contains", name: "Contains" },],
                },
                null,
              ];
            }

            let actionButtons = [
              { icon: "remove_red_eye", action: "Show", color: "info" },
              { icon: "download", action: "Download", color: "success" },
            ];

            if (
              this.privilegio.level == "ADMINISTRATOR" ||
              this.privilegio.level == "MANAGER" ||
              this.privilegio.level == "worker" ||
              this.privilegio.level == "CLERICALREP" ||
              this.privilegio.level == "PURCHASINGREP"
            ) {
              actionButtons.push({
                icon: "delete_outline",
                action: "Remove",
                color: "danger",
              });
            }

            for (let element of response.data) {
              this.contarFiles++;

              this.dataFiles.rows.push([
                new Cell(element.id, { type: "checkbox" }),
                new Cell("", { icon: "inventory_2" }),
                new Cell(element.id),
                new Cell(element.file),
                new Cell(
                  element.createdAt != null
                    ?  
                      element.createdAt
                    : null,
                  { type: "full-date" }
                ),
                new Cell(actionButtons, { type: "actions" }),
              ]);
            }

            /*this.dataTable = {
              headerRow: [
                "ID",
                "Report Name",
                "Created Date",
                "Actions",
              ],
              footerRow: [
                "ID",
                "Report Name",
                "Created Date",
                "Actions",
              ],

              dataRows: [],
            };

            this.dataTable.dataRows = [];

            response.data.forEach(
              function (element) {
                this.contarFiles++;
                this.dataTable.dataRows.push([
                  element.id,
                  element.file,
                  element.createdAt,
                  "",
                ]);
              }.bind(this)
            );*/
          }
          this.loadingDataFiles = false;
        },
        (error) => {
          console.log(<any>error);
          this.loadingDataFiles = true;
        }
      );
  }

  allComplete() {
    for (const row of this.dataFolder.dataRows) {
      if (!row[5]) {
        return false;
      }
    }
    return true;
  }

  setAll(e) {
    for (const row of this.dataFolder.dataRows) {
      row[5] = e;
    }
  }

  archiveBulk() {
    swal
      .fire({
        title: "Are you sure you want to archive the selected folders?",
        icon: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          cancelButton: "gts-btn-primary-outline",
          confirmButton: "gts-btn-primary",
        },
        confirmButtonText: "Proceed",
      })
      .then((result) => {
        if (result.value) {
          const bulk = this.bulk.map((element) => {
            //return element[0].value;
            return element;
          });
          //console.log("bulk => ",  bulk);

          this.archiveService.archiveBulk(bulk, "archived").subscribe((r) => {
            //console.log("response => ", r);

            swal.fire({
              title: "The folders have been archived correctly",
              text: "",
              icon: "success",
              buttonsStyling: false,
              customClass: {
                confirmButton: "gts-btn-primary",
              },
              timer: 2000,
              timerProgressBar: true,
            });
            this.segundogetSubFolders();

            let files_list =
              this.el.nativeElement.querySelectorAll(".classfile");
            console.log("files_list => ", files_list);
          });
        }
      });
  }

  doRefresh() {
    window.location.reload();
  }

  async inicioGetFolder() {
    //inicioGetFolder = async() => {
    let responsefolder = await this._folderService
      .getFolder(this.token, this.idFolder)
      .toPromise()
      .then(
        (response) => {
          //console.log("1- get folder");
          //console.log(response);
          //inicia success
          if (response.status == "success") {
            this.folderinterno = response.data;
            this.breadcrumbs = response.breadcrumbs;
            // response.data.name -> numero de PO
            // Inicia busqueda de processing
            if (this.fullPermission === 1) {
              this.poID = null;
              this._folderService
                .getPOid(this.token, response.data.name)
                .subscribe((responsePO) => {
                  //console.log("PO:");
                  // console.log(responsePO);
                  if (responsePO.status === "success") {
                    this.poID = responsePO.data.id;
                  } else {
                    this.poID = null;
                  }
                });
            }

            // Finaliza busqueda de processing
            this.companyId = response.data.companyId;
            //  console.log("companyId "+ this.companyId);
            this.idOwner = 0;
            if (response.data && response.data.user && response.data.user.id)
              this.idOwner = response.data.user.id;
            this.hasparent = response.data.hasParent;

            if (
              this.privilegio.level == "ADMINISTRATOR" ||
              this.privilegio.level == "MANAGER" ||
              this.privilegio.level == "PURCHASINGREP" ||
              this.privilegio.level == "worker" ||
              this.privilegio.level == "WAREHOUSE SUPERVISOR" ||
              this.privilegio.level == "TECH SUPERVISOR" ||
              this.privilegio.level == "TECHREP" ||
              this.privilegio.level == "CLERICALREP"
            ) {
              this.getListUsers(this.companyId);
              //console.log("1- postgestlisusers");
              this.filteredClientes = this.myControlClientes.valueChanges.pipe(
                startWith<string | UserList>(""),
                map((value) =>
                  typeof value === "string" ? value : value.name
                ),
                map((name) =>
                  name ? this._filterClientes(name) : this.clientes.slice()
                )
              );

              this.filteredGroups = this.myControlGroups.valueChanges.pipe(
                startWith<string | GroupList>(""),
                map((value) =>
                  typeof value === "string" ? value : value.name
                ),
                map((name) =>
                  name
                    ? this._filterGroups(name)
                    : this.permissionsgroups.slice()
                )
              );
            }

            if (
              this.privilegio.level == "ADMINISTRATOR" ||
              this.privilegio.level == "MANAGER" ||
              this.privilegio.level == "PURCHASINGREP" ||
              this.privilegio.level == "worker" ||
              this.privilegio.level == "WAREHOUSE SUPERVISOR" ||
              this.privilegio.level == "TECH SUPERVISOR" ||
              this.privilegio.level == "TECHREP" ||
              this.privilegio.level == "CLERICALREP"
            ) {
              this.fullPermission = 1;
            } else {
              this.fullPermission = response.permission.fullPermission;
            }
            this.urlUpload =
              "https://itaderp.com/script-upload/dashboard-upload.php?idfolder=" +
              this.idFolder +
              "&idowner=" +
              this.idOwner +
              "&apikey=" +
              this.apiCompany;

            // this.urlUpload = sanitizer.bypassSecurityTrustResourceUrl('https://itaderp.com/script-upload/dashboard-upload.php?idfolder=' + this.idFolder);
            this.urlUpload =
              this.sanitizerGlobal.bypassSecurityTrustResourceUrl(
                this.urlUpload
              );

            //console.log("1- acabamos");
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }

          return this.fullPermission;
        },
        (error) => {
          console.log(<any>error);
        }
      );
    if ((await typeof responsefolder) !== "undefined") {
      //console.log(responsefolder);
      //2-inicia getSubFolders
      let varsegundo = this.segundogetSubFolders();
      let files_list = this.el.nativeElement.querySelectorAll(".classfile");
      console.log("files_list => ", files_list);
      //console.log("varsegundo: " + varsegundo);
      //2-fin getSubFolders
    }
  }

  getAllPacientes(e = null, newfilter = true) {
    this._route.params.forEach((params: Params) => {
      let page = +params["page"];

      if (!page) {
        page = 1;
      }

      let parent = this.idFolder;

      if (
        this.privilegio.level == "ADMINISTRATOR" ||
        this.privilegio.level == "MANAGER" ||
        this.privilegio.level == "PURCHASINGREP" ||
        this.privilegio.level == "worker" ||
        this.privilegio.level == "WAREHOUSE SUPERVISOR" ||
        this.privilegio.level == "TECH SUPERVISOR" ||
        this.privilegio.level == "TECHREP" ||
        this.privilegio.level == "CLERICALREP"
      ) {
        this.typeFolders = "ALL";
      } else if (this.privilegio.level == "worker") {
        this.typeFolders = "ALL";
      } else {
        this.typeFolders = "USER";
      }

      this.loading = true;
      this._folderService
        .getSubFolders(
          this.token,
          e !== null ? e.page : 1,
          e !== null ? e.perPage : 10,
          e !== null
            ? (this.campoBusqueda = e.search)
            : (this.campoBusqueda = ""),
          this.filtros,
          this.typeFolders,
          this.idFolder
        )
        .subscribe(
          (response) => {
            console.log(response);
            if (response.status == "success") {
              this.pacientes = response.data;

              this.dataFolder.dataRows = [];
              if (this.typeFolders == "ALL") {
                this.pacientes.forEach(
                  function (element) {
                    this.dataFolder.dataRows.push([
                      element.id,
                      element.name,
                      element.user.name + " " + element.user.surname,
                      "",
                    ]);
                  }.bind(this)
                );
              } else {
                this.pacientes.forEach(
                  function (element) {
                    this.dataFolder.dataRows.push([
                      element.folderList.id,
                      element.folderList.name,
                      element.folderList.user.name +
                        " " +
                        element.folderList.user.surname,
                      "",
                    ]);
                  }.bind(this)
                );
              }

              this.loading = false;
              this.getFiles(this.idFolder);

              //total paginas
              this.pages = [];
              for (let i = 0; i < response.total_pages; i++) {
                this.pages.push(i);
              }

              //pagina anterior
              if (page >= 2) {
                this.pagePrev = page - 1;
              } else {
                this.pagePrev = page;
              }

              //pagina siguiente
              if (page < response.total_pages) {
                this.pageNext = page + 1;
              } else {
                this.pageNext = page;
              }
            } else {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
            }
          },
          (error) => {
            console.log(<any>error);
          }
        );
    });
  }

  deleteFolder() {
    this.loading = true;
    let id = $("#borrarFolder").val();
    //console.log(id + "aqui");
    this._folderService.deleteFolder(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          //this._router.navigate(['/']);
          alert("Done");
          // this.getFiles(this.idFolder);
          //console.log("deleted");
          this.segundogetSubFolders();
          this.loading = false;
        } else {
          alert("Error");
        }
      },
      (error) => {
        console.log(<any>error);
        alert("Error");
      }
    );
  }

  deleteUser() {
    this.loading = true;
    let id = $("#borrarUser").val();
    //console.log(id + "aqui");
    this._fileService.deleteFile(this.token, id).subscribe(
      (response) => {
        if (response.status == "success") {
          //this._router.navigate(['/']);
          alert("Done");
          // this.getFiles(this.idFolder);
          //console.log("deleted");
          this.loading = false;
        } else {
          alert("Error");
        }
      },
      (error) => {
        console.log(<any>error);
        alert("Error");
      }
    );
  }

  deleteCVFile(fileId: string) {
    swal
      .fire({
        title: "Do you really want to delete this file?",
        icon: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          cancelButton: "gts-btn-primary-outline",
          confirmButton: "gts-btn-primary",
        },
        confirmButtonText: "Yes, delete it!",
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.confirmDeleteCVFile(fileId);
        }
      });
  }

  confirmDeleteCVFile(fileId: string) {
    this.loading = true;
    this._fileService.deleteFile(this.token, fileId).subscribe(
      (response) => {
        this.loading = false;
        if (response.status === "success") {
          swal.fire({
            title: "Deleted!, Your file has been deleted.",
            icon: "success",
            buttonsStyling: false,
            customClass: {
              confirmButton: "gts-btn-primary",
            },
            timer: 2000,
            timerProgressBar: true,
          });
          this.getFiles(this.idFolder);
        } else {
          swal.fire({
            title: "An error occurred during file deletion.",
            icon: "error",
            buttonsStyling: false,
            customClass: {
              confirmButton: "gts-btn-primary",
            },
            timer: 2000,
            timerProgressBar: true,
          });
        }
      },
      (error) => {
        console.error(error);
        this.loading = false;
        swal.fire({
          title: "An unexpected error occurred.",
          icon: "error",
          buttonsStyling: false,
          customClass: {
            confirmButton: "gts-btn-primary",
          },
          timer: 2000,
          timerProgressBar: true,
        });
      }
    );
  }

  showSwal(type) {
    if (type === "success") {
      const Toast = swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = swal.stopTimer;
          toast.onmouseleave = swal.resumeTimer;
        },
      });
      Toast.fire({
        icon: type,
        title: "Folder has been created successfully",
      });
    } else if (type === "success-message-file") {
      swal
        .fire({
          title: "File uploaded!",
          text: "your file has been successfully uploaded",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success",
          },
        })
        .then(function (e) {
          //console.log(e);
          this.getFiles(this.idFolder);
        });
    } else if (type === "warning-message-and-confirmation") {
      swal
        .fire({
          title: "Are you sure?",
          text: "You will not be able to revert this!",

          showCancelButton: true,

          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },

          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then(function () {
          swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",

            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
        });
    }
  }

  getFiles(folder, e = null, newfilter = true) {
    this.loadingDataFiles = true;
    //console.log("permiso " + this.fullPermission);
    if (this.fullPermission == 1) {
      //console.log("entramos");

      this._fileService
        .getFilesFolder(
          this.token,
          e !== null ? e.page : 1,
          e !== null ? e.perPage : 10,
          e !== null
            ? (this.campoBusquedaFiles = e.search)
            : (this.campoBusquedaFiles = ""),
          this.filtrosFiles,
          folder
        )
        .subscribe(
          (response) => {
            // console.log(response);
            if (response.status == "success") {
              this.dataTable.dataRows = [];

              response.data.forEach(
                function (element) {
                  this.dataTable.dataRows.push([
                    element.id,
                    element.file,
                    element.createdAt,
                    "",
                  ]);
                }.bind(this)
              );
              console.log("FILES:::", this.loadingDataFiles);
              this.loadingDataFiles = false;
            } else {
              localStorage.clear();
              this._router.navigate(["/pages/lock"]);
              this.loadingDataFiles = true;
            }
          },
          (error) => {
            console.log(<any>error);
            this.loadingDataFiles = true;
          }
        );
    } else {
      // console.log("no entramos");
    }
  }

  deleteFolderfirst(folder) {
    var txt;
    var r = confirm("Are you sure to delete this folder?");
    if (r == true) {
      $("#folder" + folder).hide();
      $("#borrarFolder").val(folder);

      $("#borrarFolder").trigger("click");
    } else {
    }
  }

  deleteFolderPrompt(folderId: string) {
    swal
      .fire({
        title: "Do you really want to delete this folder?",
        icon: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          cancelButton: "gts-btn-primary-outline",
          confirmButton: "gts-btn-primary",
        },
        confirmButtonText: "Yes, delete it!",
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.confirmDeleteFolder(folderId);
        }
      });
  }

  confirmDeleteFolder(folderId: string) {
    this.loading = true;
    this._folderService.deleteFolder(this.token, folderId).subscribe(
      (response) => {
        this.loading = false;
        if (response.status === "success") {
          const Toast = swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = swal.stopTimer;
              toast.onmouseleave = swal.resumeTimer;
            },
          });
          Toast.fire({
            icon: "success",
            title: "Your folder has been deleted",
          });

          this.segundogetSubFolders();
        } else {
          swal.fire({
            title: "Error",
            text: "An error occurred during folder deletion.",
            icon: "error",
            buttonsStyling: false,
            customClass: {
              confirmButton: "gts-btn-primary",
            },
          });
        }
      },
      (error) => {
        console.error(error);
        this.loading = false;
        swal.fire({
          title: "Error",
          text: "An unexpected error occurred.",
          icon: "error",
          buttonsStyling: false,
          customClass: {
            confirmButton: "gts-btn-primary",
          },
        });
      }
    );
  }

  deleteFile(file) {
    var txt;
    var r = confirm("Are you sure to delete this file?");
    if (r == true) {
      $("#file" + file).hide();

      $("#borrarUser").val(file);

      $("#borrarUser").trigger("click");
    } else {
    }
  }

  downloadAll() {
    window.open(
      "https://www.greenteksolutions.com/web/folder/downloadall/" +
        this.idFolder +
        "/" +
        this.token +
        "?includeFiles=1",
      "_blank"
    );
  }

  downloadingState = {
    0: false, // Folders
    1: false, // Folders and Files
    2: false, // Files
  };

  downloadZip(includeFiles: number) {
    this.setDownloadingState(includeFiles, true);

    this._folderService
      .downloadFile(this.idFolder, this.token, includeFiles)
      .subscribe(
        (blob) => {
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          const nameFolder =
            this.breadcrumbs[this.breadcrumbs.length - 1].label;
          anchor.download = nameFolder + ".zip";
          anchor.href = url;
          anchor.click();
          window.URL.revokeObjectURL(url);

          this.setDownloadingState(includeFiles, false);
        },
        (error) => {
          console.error(error);
          this.setDownloadingState(includeFiles, false);
        }
      );
  }

  setDownloadingState(includeFiles: number, state: boolean) {
    if (this.downloadingState.hasOwnProperty(includeFiles)) {
      this.downloadingState[includeFiles] = state;
    }
  }

  downloadFilesZip() {
    this._folderService
      .downloadFilesZip(this.token, this.bulkFiles)
      .subscribe((data) => {
        const a = document.createElement("a");
        const objectUrl = URL.createObjectURL(data);
        a.href = objectUrl;
        const nameFolder = this.breadcrumbs[this.breadcrumbs.length - 1].label;
        a.download = nameFolder + ".zip";
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  downloadFile(file) {
    // console.log(file);
    window.open(
      "https://www.greenteksolutions.com/web/folder/downloadfile/" +
        file +
        "/" +
        this.token,
      "_blank"
    );
  }

  openFile(idFile) {
    // console.log(idFile);

    this._fileService.getFile(this.token, idFile).subscribe(
      (response) => {
        // console.log(response);
        this.loading = false;
        if (response.status == "success") {

          if(response.data.extraData){
            window.open(
            response.data.extraData +
              response.data.folder +
              "/" +
              response.data.file,
            "_blank"
          );
          } else {
            window.open(
            "https://itaderp.com/script-upload" +
              response.data.folder +
              "/" +
              response.data.file,
            "_blank"
          );
          }
          
        } else {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  getFolderInfo() {
    this._route.params.forEach((params: Params) => {
      let id = +params["id"];
      let page = 1;
      this.idFolder = id;

      this._folderService.getFolder(this.token, id).subscribe(
        (response) => {
          // console.log(response);

          if (response.status == "success") {
            this.folderinterno = response.data;
            // console.log("this.folderinterno:::", this.folderinterno);
            if (response.data && response.data.user && response.data.user.id)
              this.idOwner = response.data.user.id;

            if (
              this.privilegio.level == "ADMINISTRATOR" ||
              this.privilegio.level == "MANAGER" ||
              this.privilegio.level == "PURCHASINGREP" ||
              this.privilegio.level == "worker" ||
              this.privilegio.level == "WAREHOUSE SUPERVISOR" ||
              this.privilegio.level == "TECH SUPERVISOR" ||
              this.privilegio.level == "TECHREP" ||
              this.privilegio.level == "CLERICALREP"
            ) {
              this.fullPermission = 1;
            } else {
              this.fullPermission = response.permission.fullPermission;
            }

            this.urlUpload =
              "https://itaderp.com/script-upload/dashboard-upload.php?idfolder=" +
              this.idFolder +
              "&idowner=" +
              this.idOwner +
              "&apikey=" +
              this.apiCompany;
            // console.log(this.urlUpload);
            // this.urlUpload = sanitizer.bypassSecurityTrustResourceUrl('https://itaderp.com/script-upload/dashboard-upload.php?idfolder=' + this.idFolder);
            this.urlUpload =
              this.sanitizerGlobal.bypassSecurityTrustResourceUrl(
                this.urlUpload
              );
            // console.log(this.urlUpload);
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
    });
  }

  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

  private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.clientes.filter(
      (option) => option.name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  displayFnGroup(user?: GroupList): string | undefined {
    return user ? user.name : undefined;
  }

  private _filterGroups(name: string): GroupList[] {
    const filterValue = name.toLowerCase();

    return this.permissionsgroups.filter(
      (option) => option.name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  getListUsers(type) {
    // console.log("entramos getListUsers");

    this.loading = true;
    this._userService.getAllUsersLite(this.token, type).subscribe(
      (response) => {
        //console.log("lite");
        //  console.log(response);
        this.clientes = [];
        //  console.log(this.clientes);
        this.loading = false;
        if (response.status == "success") {
          response.data.forEach(
            function (element) {
              // console.log(element);
              //  console.log("llenamos clientes getlistusers");
              this.clientes.push({
                value: element.id,
                name: element.name + " " + element.surname + " # " + element.id,
              });
            }.bind(this)
          );
        } else {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  selectGroupPermission() {
    // console.log("filepermissionSelected => ", this.filepermissionSelected);

    this.loading = true;

    let valSend = {
      idFolder: this.idFolder,
      idpermiso: this.filepermissionSelected.data,
    };

    this._folderPermissionService.createBulk(this.token, valSend).subscribe(
      (response) => {
        // console.log(response);
        if (response.status == "success") {
          this._folderPermissionService
            .getFolder(this.token, this.idFolder)
            .subscribe(
              (response) => {
                // console.log(response);
                this.filepermissionSelected = null;
                if (response.status == "success") {
                  this.permissions = response.data;
                }
              },
              (error) => {
                console.log(<any>error);
              }
            );

          this.loading = false;
        } else {
          alert(response.msg);
        }
      },
      (error) => {
        console.log(<any>error);
        alert("Error");
      }
    );
  }

  selectUserPermission() {
    this.loading = true;

    let valSend = {
      idFolder: this.idFolder,
      idpermiso: this.folderPermissions.user_id.value,
    };

    this._folderPermissionService.create(this.token, valSend).subscribe(
      (response) => {
        // console.log(response);
        if (response.status == "success") {
          this._folderPermissionService
            .getFolder(this.token, this.idFolder)
            .subscribe(
              (response) => {
                //  console.log(response);

                if (response.status == "success") {
                  this.permissions = response.data;
                }
              },
              (error) => {
                console.log(<any>error);
              }
            );

          this.loading = false;
        } else {
          alert(response.msg);
        }
      },
      (error) => {
        console.log(<any>error);
        alert("Error");
      }
    );
  }

  receivedFolderDrop(event) {
    console.log("event receivedFolderDrop => ", event);
    this.idfoldertomove = event.idfolder;
    swal.fire({
      text: "Moving file into folder " + this.idfoldertomove + "...",
      timer: 2000,
      showConfirmButton: false,
    });
    this._fileService
      .changefolder(this.token, this.idfiletomove, {
        idfolder: this.idfoldertomove,
      })
      .subscribe(
        (response) => {
          if (response.status == "error") {
            console.log(response.msg);
            this.showSwal(response.msg);

            this.mtds.notifyError(response.msg, response.code);
          } else {
            this.getFiles(this.idFolder);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }

  ngAfterViewInit() {
    $("body").on("change", "select[name='datafolders_length']", function (e) {
      // 2nd (B)
      let varnew = $("select[name='datafolders_length']").val();
      // console.log(varnew);
      localStorage.setItem("psshowuser", varnew);
    });

    $(document).on("dragstart", '[id^="file"]', (event: DragEvent) => {
      //event.preventDefault();

      const targetElement = event.target as HTMLElement; // Type assertion
      const id = targetElement.getAttribute("id");
      if (id) {
        console.log("file id to move: ", id);
        this.idfiletomove = id.replace("file", ""); // removing "file" from the string
        console.log("this.idfiletomove => ", this.idfiletomove);
      }
    });
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    console.log("Element dropped => ", event);
    alert("Element dropped!");
  }

  ngAfterViewChecked() {
    // console.log("ngAfterViewChecked fired!");
    let psshowuser: any = localStorage.getItem("psshowuser");

    if (psshowuser)
      if (!psshowuser) {
        psshowuser = 10;
      }

    if (psshowuser <= 1) psshowuser = 10;

    const table = $("#datatables").DataTable();
    if (!table) {
      $("#datatables").DataTable({
        dom: "Bflrtip",
        buttons: [
          {
            extend: "copy",
            exportOptions: {
              columns: ":visible",
            },
          },
          {
            extend: "csv",
            exportOptions: {
              columns: ":visible",
            },
          },
          {
            extend: "excel",
            exportOptions: {
              columns: ":visible",
            },
          },
          {
            extend: "pdf",
            exportOptions: {
              columns: ":visible",
            },
          },
          {
            extend: "print",
            exportOptions: {
              columns: ":visible",
            },
          },
          "colvis",
        ],
        pagingType: "full_numbers",
        lengthMenu: [
          [10, 25, 50, -1],
          [10, 25, 50, "All"],
        ],
        responsive: true,
        language: {
          search: "_INPUT_",
          searchPlaceholder: "Search records",
        },
      });

      const table = $("#datatables").DataTable();

      // Delete a file
      table.on("click", ".remove", function (e) {
        e.preventDefault();

        var txt;
        var r = confirm("Are you sure to delete this file?");
        if (r == true) {
          const $tr = $(this).closest("tr");

          const data = table.row($tr).data();
          // console.log(table);
          table.row($tr).remove().draw();
          $("#borrarUser").val(data[0]);

          $("#borrarUser").trigger("click");
        } else {
        }
      });
    }

    $(".card .material-datatables label").addClass("form-group");
  }

  goFolder(folder) {
    // console.log(folder);
    // this._router.navigate(['/tables/listfiles', folder]);
    window.location.href = "/tables/listfiles/" + folder;
  }

  upFolder() {
    //  console.log(this.hasparent);
    // this._router.navigate(['/tables/listfiles', folder]);
    if (this.hasparent != 0)
      window.location.href = "/tables/listfiles/" + this.hasparent;
    else this._router.navigate(["/tables/listfiles"]);
  }

  //NEW UI

  optionsButtonSelect: { value: string; label: string }[] = [
    { value: "foldersFiles", label: "Folders & Files" },
    { value: "folders", label: "folders" },
    { value: "files", label: "files" },
  ];

  setOptionsButtonSelect() {
    this.optionsButtonSelect = [];

    this.optionsButtonSelect = [
      // { value: 'Folders & Files', label: 'Folders & Files (' + (this.totalItems + this.totalItemsFiles) + ')'},
      {
        value: "foldersFiles",
        label:
          "Folders (" +
          this.totalItems +
          ")" +
          " & Files (" +
          this.totalItemsFiles +
          ")",
      },
      { value: "folders", label: "Folders (" + this.totalItems + ")" },
      { value: "files", label: "Files (" + this.totalItemsFiles + ")" },
    ];
    //this.optionSelectMenuTrigger = "foldersFiles";
  }

  setOptionsButtonSelectArchiveFolders() {
    this.optionsButtonSelect = [];
    this.optionsButtonSelect = [
      {
        value: "archivedFolders",
        label: "Archived Folders (" + this.totalPaginasArchived + ")",
      },
    ];
    this.optionSelectMenuTrigger = "archivedFolders";
  }

  optionSelectMenuTrigger = "foldersFiles";

  archivedFolders = false;

  onScroll(event: WheelEvent): void {
    event.stopPropagation();
  }
  getClass() {
    if (this.showDtButtons) return 'tdbtn';
    return 'tdbtn2'
  }
  getClassConta() {
    if (this.showDtButtons) return 'with-buttons';
    return 'with-buttons2'
  }
  showDtButtons: boolean = false;
  onToggleButtons(show: boolean) {
    this.showDtButtons = show;
  }
  menuTriggerToShow(newValue: string) {
    this.bulkArchivedFolders = [];
    this.bulk = [];
    this.segundogetSubFolders();
  }

  showModalAdvancedSearch() {
    $("#modalAdvancedSearch").modal("show");
  }

  showModalPOSearch() {
    $("#modalPOSearch").modal("show");
  }

  showModalPermissions() {
    $("#modalPermissions").modal("show");
  }

  showModalAddFiles() {
    $("#modalAddFiles").modal("show");
  }

  // My archived folders

  public mtdsArchivedFolders: Methods = new Methods();
  public bulkArchivedFolders: Array<any> = [];

  public dataArchivedFolders: DinamicData = new DinamicData([
    "check",
    "Type",
    "ID",
    "Folder Name",
    "State",
    "City",
    "Status",
    "Created Date",
    "Actions",
  ]);

  loadingDataArchivedFolders = true;
  getArchivedFolders(e = null, newfilter = true) {
    this.loadingDataArchivedFolders = true;
    this.bulkArchivedFolders = [];
    this.dataArchivedFolders.rows = [];
    this.archiveService
      .getFolders(
        e !== null ? e.page : 1,
        e !== null ? e.perPage : 10,
        e !== null
          ? (this.campoBusquedaArchived = e.search)
          : (this.campoBusquedaArchived = ""),
        this.filtrosArchived,
        this.idFolder
      )
      .subscribe(
        (r) => {
          console.log(r);

          if (r.code === 400 && r.msg === "Authorization not valid") {
            /*this.mtdsArchivedFolders.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);*/
          } else if (r.status === "success") {
            this.paginaActualArchived = Number(r.page_actual);
            this.itemsPorPaginaArchived = String(r.items_per_page);
            this.totalItemsArchived = Number(r.total_items_count);
            this.totalPaginasArchived = Number(r.total_pages);

            if (newfilter) {
              this.filtrosArchived = [
                null,
                null,
                {
                  key: "filter_id",
                  title: "ID",
                  value: "",
                  type: "contains",
                  key_type: "filter_id_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_vendor",
                  title: "Folder Name",
                  value: "",
                  type: "contains",
                  key_type: "filter_vendor_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_state",
                  title: "State",
                  value: "",
                  type: "contains",
                  key_type: "filter_state_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_city",
                  title: "City",
                  value: "",
                  type: "contains",
                  key_type: "filter_city_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_status",
                  title: "Status",
                  value: "",
                  type: "contains",
                  key_type: "filter_status_type",
                  type_options: [
                    { value: "nofilter", name: "No Filter" },
                    { value: "contains", name: "Contains" },
                    { value: "startswith", name: "Starts With" },
                    { value: "endswith", name: "Ends With" },
                    { value: "equalto", name: "Equal To" },
                  ],
                },
                {
                  key: "filter_date",
                  title: "Created Date",
                  value: "",
                  type: "contains",
                  key_type: "filter_date_type",
                  type_options: [ { value: "contains", name: "Contains" },],
                },
                null,
              ];
            }

            const actionButtons = [
              { icon: "remove_red_eye", action: "Show", color: "info" },
              // { icon: 'delete_outline', action: 'Remove', color: 'danger' }
            ];

            for (let element of r.data) {
              this.dataArchivedFolders.rows.push([
                new Cell(element.id, { type: "checkbox" }),
                new Cell("", { icon: "folder" }),
                new Cell(element.id),
                new Cell(element.name),
                new Cell(element.poState),
                new Cell(element.poCity),
                new Cell(element.poStatus),
                new Cell(
                  element.createdAt != null
                    ? 
                      element.createdAt
                    : null
                ),
                new Cell(actionButtons, { type: "actions" }),
              ]);
            }
            this.loadingDataArchivedFolders = false;
          } else {
            this.mtdsArchivedFolders.notifyError(r.msg, r.code);
            this.loadingDataArchivedFolders = true;
          }
        },
        (error) => {
          this.mtdsArchivedFolders.notifyError(error.statusText, error.status);
          this.loadingDataArchivedFolders = true;
        }
      );
  }

  actionArchiveFolders(e) {
    console.log(e);
    switch (e.action) {
      case "Show":
        this.archivedFolders = false;
        this._router.navigate(["/tables/listfiles", e.id]);
        break;
      default:
        break;
    }
  }

  actionFiles(e) {
    console.log(e);
    switch (e.action) {
      case "Show":
        this.openFile(e.id);
        break;
      case "Download":
        this.downloadFile(e.id);
        break;
      case "Remove":
        this.deleteCVFile(e.id);
        break;
      default:
        break;
    }
  }

  onToggleChange(event?: MatSlideToggleChange) {
    if (event && event.checked) {
      this.setOptionsButtonSelectArchiveFolders();
      this.archivedFolders = true;
      this.getArchivedFolders();
    } else {
      this.optionSelectMenuTrigger = 'foldersFiles';
      this.setOptionsButtonSelect();
      this.archivedFolders = false;
      this.segundogetSubFolders();
    }
    this.bulkArchivedFolders = [];
    this.bulkFiles = [];
    this.bulk = [];
  }

  unarchive() {
    swal
      .fire({
        title: "Are you sure to unarchive selected folders?",
        icon: "warning",
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {
          cancelButton: "gts-btn-primary-outline",
          confirmButton: "gts-btn-primary",
        },
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Continue",
      })
      .then((result) => {
        if (result.value) {
          console.log(this.bulkArchivedFolders);
          const bulkArchivedFolders = this.bulkArchivedFolders.map(
            (element) => {
              //return element[0].value;
              return element;
            }
          );

          this.archiveService
            .archiveBulk(bulkArchivedFolders, "unarchived")
            .subscribe((r) => {
              console.log(r);

              if (r.code === 400 && r.msg === "Authorization not valid") {
                this.mtdsArchivedFolders.notifyError(
                  "Your session has expired"
                );
                localStorage.clear();
                this._router.navigate(["/pages/lock"]);
              } else if (r.status === "success") {
                this.getArchivedFolders();
                swal.fire({
                  title: "Successfully unarchived folders!",
                  text: "",
                  icon: "success",
                  buttonsStyling: false,
                  customClass: {
                    confirmButton: "gts-btn-primary",
                  },
                  timer: 2000,
                  timerProgressBar: true,
                });
              } else {
                this.mtdsArchivedFolders.notifyError(r.msg, r.code);
              }
            });
        }
      });
  }
}

@Component({
  selector: "new-folder",
  templateUrl: "new-folder.html",
  providers: [
    UserService,
    FileService,
    FolderService,
    FilesPermissionGroupService,
  ],
})
export class NewSubFolder implements OnInit {
  public userinterno;
  public tableFolder;
  public loading: boolean = false;
  public identity;
  public token;
  public user: User;
  public status_user;
  public privilegio;
  public pacientes;
  public folder;
  public productosResponse;
  myControl = new FormControl();
  myControlClientes = new FormControl();
  public folderParent;
  groups: UserList[] = [];

  public permissionsShow;
  public companyId;
  public permissions_imported;
  public selectedUsers: any[] = [];
  public usertoAssign: Array<any> = [];
  users = new FormControl();
  sexos = [
    { value: "1", viewValue: "Male" },
    { value: "0", viewValue: "Female" },
  ];
  public groupSelected;
  public arrayUsers: any[] = [];

  clientes: UserList[] = [];

  filteredClientes: Observable<UserList[]>;
  filteredGroups: Observable<UserList[]>;
  private _filterGroups(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.groups.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }
  constructor(
    public dialogRef: MatDialogRef<NewSubFolder>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _userService: UserService,
    private _fileService: FileService,
    private _folderService: FolderService,
    private _route: ActivatedRoute,
    private _filesPermissionsGroupsService: FilesPermissionGroupService,
    private _router: Router
  ) {
    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
    this.folder = data;
    console.log(this.folder, "myfolder");
    this.permissions_imported = data.permissions_imported;

    this.folderParent = data.folderParent;
    // console.log(this.folderParent);
    this.folder.hasparent = this.folderParent;
    //  console.log(data);
    this.folder.permissions = this.folder.permissions || [];
    this.permissionsShow = [];
    this.getGroups();
    this.filteredGroups = this.myControl.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value?.name || "")),
      map((name) => (name ? this._filterGroups(name) : this.groups.slice()))
    );

    this.getUsersLite();
  }

  transformUsersToArray(data: any[]): { value: number; name: string }[] {
    return data.map((item) => ({
      value: item.user.id, // 'id' como 'value'
      name: `${item.user.name} ${item.user.surname}`, // 'name' + 'surname' como 'name'
    }));
  }
  async getUsersLite() {
    // console.log(this.permissions_imported, "imported");
    await this._userService
      .getAllUsersLite(this.token, this.folder.folder.companyId)
      .subscribe(
        (response) => {
          //console.log(response);
          if (response.status == "success") {
            this.loading = false;
            this.pacientes = [];
            this.arrayUsers = response.data;
            if (this.folder.permissions) {
              this.folder.permissions = this.getUsersByIds(
                this.folder.permissions
              );
            }
            if (this.folder.permissions_imported) {
              console.log("sisehace");
              this.folder.permissions = this.transformUsersToArray(
                this.permissions_imported
              );
            }
            console.log(this.folder.permissions_imported.user, "user");
            console.log(this.folder.permissions_imported, "userssss");

            //this.clientes = null;
            this.arrayUsers.forEach(
              function (element) {
                this.usertoAssign.push({
                  value: element.id,
                  name:
                    element.name + " " + element.surname + " # " + element.id,
                });
              }.bind(this)
            );
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }
  getUsersByIds(ids: number[]) {
    return this.arrayUsers
      .filter((user) => ids.includes(user.id))
      .map((item) => ({
        value: item.id,
        name: item.name + " " + item.surname + " # " + item.id,
      }));
  }
  compareUsers(user1: any, user2: any): boolean {
    return user1 && user2 ? user1.id === user2.id : user1 === user2;
  }
  onInputFocus(): void {
    // Ejecuta el filtro para mostrar todas las opciones cuando el input tiene foco
    this.filteredGroups = of(this.groups);
  }
  ngOnInit() {
    // this.tableFolder.destroy();
    let me = this;

    //console.log(this.clientes);
    if (this.identity == null && this.identity.sub) {
      this._router.navigate(["/pages/lock"]);
    } else {
    }
    // this.getListUsers(this.folder.folder.companyId);

    this.filteredClientes = this.myControlClientes.valueChanges.pipe(
      startWith<string | UserList>(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) =>
        name ? this._filterClientes(name) : this.pacientes.slice()
      )
    );

    // console.log("terminamos");

    // console.log("this.permissions_imported => ", this.permissions_imported);
    this.permissions_imported.forEach(function (element) {
      // console.log("element => ", element);
      me.folder.permissions.push(element.user.id);
      me.permissionsShow.push(element.user.name + " " + element.user.surname);
    });

    console.log("oninit this.folder => ", this.folder);
  }

  onHumanSelected(option) {
    console.log(option);
    this.groupSelected = option.value;
    console.log("groupsel", this.groupSelected);
  }

  displayFn(user?: UserList): string | undefined {
    return user ? user.name : undefined;
  }

  pipeusers(user) {
    console.log(user.name, "user");
    return user.name;
  }
  private _filterClientes(name: string): UserList[] {
    const filterValue = name.toLowerCase();

    return this.pacientes.filter(
      (option) => option.name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  getGroups() {
    // console.log(type);
    this.loading = true;
    this._filesPermissionsGroupsService
      .getGroups(this.token, this.folder.folder.companyId)
      .subscribe(
        (response) => {
          this.loading = false;
          if (response.status == "success") {
            this.groups = response.data;
          } else {
            localStorage.clear();
            this._router.navigate(["/pages/lock"]);
          }
        },
        (error) => {
          console.log(<any>error);
        }
      );
  }
  getListUsers(type) {
    // console.log(type);
    this.loading = true;
    this._userService.getAllUsersLite(this.token, type).subscribe(
      (response) => {
        // console.log("lite");
        // console.log(response);
        this.pacientes = [];
        this.loading = false;
        if (response.status == "success") {
          //this.clientes = null;
          response.data.forEach(
            function (element) {
              this.usertoAssign.push({
                value: element.id,
                name: element.name + " " + element.surname + " # " + element.id,
              });
            }.bind(this)
          );
          // console.log(this.pacientes);
        } else {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  selectPacient(event) {
    //console.log(event.value);

    // console.log("selectPacient fired => ", event.value);

    this._userService.getUser(this.token, event.value).subscribe(
      (response) => {
        if (response.status == "success") {
          this.userinterno = response.data;
          //console.log(this.userinterno);
          this.folder.user_id = this.userinterno.id;
        }
      },
      (error) => {
        console.log(<any>error);
      }
    );
  }

  selectUserPermission() {
    let userSelected = $("#nameCliente").val();
    // console.log("selectUser this.folder => ", this.folder);
    this.folder.permissions.push(this.folder.user_id.value);
    this.permissionsShow.push(this.folder.user_id.name + "");
    // console.log(this.folder);
  }

  addItem() {
    //console.log("add item");
  }

  onNoClick(): void {}
}
